enum Mutaion {
    INIT_USER = "INIT_USER",
    SET_CURRENT_STATEMENT = "SET_CURRENT_STATEMENT",
    SET_LOGGED_IN = "SET_LOGGED_IN",
    SET_MAIL_ADDRESS = "SET_MAIL_ADDRESS"
}
export default Mutaion;
